/**
 *  @name MastheadSearch()
 *  @desc creates a click event listener that toggles the is-hidden class on the search modal
 */
const MastheadSearch = () => {
    // the masthead search button
    const searchBtn = document.querySelector(".masthead__search-btn");


    searchBtn.addEventListener("click", function(e) {
        // the modal parent
        let modalOverlay = document.querySelector(".l-overlay-modal");

        // the modal child (the search part of the modal)
        let searchModal = modalOverlay.querySelector(".modal__search");

        // toggle the classes on both elements per RDS spec.
        modalOverlay.classList.toggle("is-hidden");
        searchModal.classList.toggle("is-hidden");
    })
};

export default MastheadSearch;